(function () {
  'use strict';

  // Mobile drawer toggle
  function initMobileDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      var firstFocusable = drawer.querySelector('a, button');
      if (firstFocusable) firstFocusable.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
      setTimeout(function () { drawer.hidden = true; }, 250);
      toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) close(); else open();
    });

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Document-level catch-all: while drawer is open, any tap outside the panel closes it.
    // Uses both pointerdown (fast) and click (fallback) to maximize reliability across devices.
    function maybeClose(e) {
      if (!drawer.classList.contains('is-open')) return;
      var t = e.target;
      if (t.closest && t.closest('.mobile-drawer__panel')) return;
      if (t.closest && t.closest('[data-menu-toggle]')) return;
      close();
    }
    document.addEventListener('pointerdown', maybeClose, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  // Cart drawer + AJAX add-to-cart
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCartDrawer() {
    try {
      var res = await fetch('/?section_id=cart-drawer-contents', { headers: { 'Accept': 'text/html' } });
      if (!res.ok) return;
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('#shopify-section-cart-drawer-contents');
      var current = document.querySelector('#shopify-section-cart-drawer-contents');
      if (newSection && current) current.replaceWith(newSection);
      initCartUpsells();
    } catch (e) { console.error(e); }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.classList.add('drawer-open');
    document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 250);
    document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        openCartDrawer();
        return;
      }
      var closer = e.target.closest('[data-cart-close]');
      if (closer && drawer.contains(closer)) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });

    // Quantity +/- and remove via event delegation (survives re-rendering)
    drawer.addEventListener('click', async function (e) {
      var item = e.target.closest('[data-cart-line]');
      if (!item) return;

      var key = item.getAttribute('data-key');
      var input = item.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input ? input.value : '1', 10) || 0;

      if (e.target.closest('[data-cart-qty-increase]')) {
        await changeCart(key, qty + 1);
      } else if (e.target.closest('[data-cart-qty-decrease]')) {
        await changeCart(key, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-cart-remove]')) {
        await changeCart(key, 0);
      }
    });

    drawer.addEventListener('change', async function (e) {
      if (!e.target.matches('[data-cart-qty-input]')) return;
      var item = e.target.closest('[data-cart-line]');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      await changeCart(key, qty);
    });
  }

  async function changeCart(key, quantity) {
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      var cart = await res.json();
      updateCartCount(cart.item_count);
      await refreshCartDrawer();
    } catch (e) { console.error(e); }
  }

  function formPostsToCartAdd(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var act = (form.getAttribute('action') || '').trim();
    if (act) {
      if (act === '/cart/add' || act.endsWith('/cart/add')) return true;
      if (/\/cart\/add(\/|\?|$)/.test(act)) return true;
      try {
        var u = new URL(act, window.location.href);
        if (/\/cart\/add(\/|\?|$)/.test(u.pathname)) return true;
      } catch (err) { /* ignore */ }
    }
    if (form.classList.contains('pdp-form') && form.querySelector('input[name="id"]') && form.querySelector('[name="add"]')) return true;
    return false;
  }

  // AJAX add-to-cart → open drawer
  function initCartForm() {
    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (!formPostsToCartAdd(form)) return;

      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'add') {
        submitter = form.querySelector('[data-pdp-atc], button[name="add"], input[name="add"]');
      }
      if (!submitter || submitter.name !== 'add') return;

      event.preventDefault();
      submitter.disabled = true;

      try {
        var formData = new FormData(form);
        var addRes = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!addRes.ok) throw new Error('Add to cart failed');

        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        updateCartCount(cart.item_count);

        await refreshCartDrawer();

        // Show the toast notification instead of opening the cart drawer
        var addedTitle = '';
        var nameField = formData.get('id');
        if (cart.items && cart.items.length) {
          var last = cart.items[cart.items.length - 1];
          addedTitle = last.product_title || last.title || '';
        }
        // Toast anchor: sticky bar sets form._caponNotifyAnchor before requestSubmit (submitter is still main ATC).
        var anchorForToast = form._caponNotifyAnchor;
        if (!anchorForToast || !anchorForToast.isConnected || !anchorForToast.matches('[data-pdp-sticky-atc]')) {
          anchorForToast = form.querySelector('[data-pdp-atc], button[name="add"], input[name="add"]') || submitter;
        }
        form._caponNotifyAnchor = null;
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { title: addedTitle, atcAnchor: anchorForToast }
        }));
      } catch (err) {
        console.error(err);
        form.submit();
      } finally {
        submitter.disabled = false;
      }
    });
  }

  // Infinite scroll for collection pages
  // ============ Scroll restoration for grid pages ============
  // Caches the rendered grid + scroll position when leaving for a product,
  // restores both on back-navigation so the user lands on the exact card.
  var GRID_RESTORE_KEY = 'capon:grid-restore';
  var GRID_RESTORE_TTL_MS = 30 * 60 * 1000; // 30 min

  // Find the topmost card currently visible — used as a stable anchor for restoration
  // (more robust than pixel-Y across viewport changes like the mobile address bar).
  function findTopVisibleCard(grid) {
    var cards = grid.querySelectorAll('[data-product-card]');
    var headerOffset = 0;
    var header = document.querySelector('.site-header, [data-site-header]');
    if (header) headerOffset = header.getBoundingClientRect().bottom;
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.bottom > headerOffset && rect.top < window.innerHeight) {
        return { card: cards[i], offsetFromTop: rect.top };
      }
    }
    return null;
  }

  function saveGridState() {
    try {
      var grid = document.querySelector('[data-product-grid]');
      if (!grid) return;
      var key = window.location.pathname + window.location.search;
      var topVisible = findTopVisibleCard(grid);
      var anchor = null;
      if (topVisible && topVisible.card) {
        anchor = {
          handle: topVisible.card.getAttribute('data-product-handle') || '',
          id: topVisible.card.getAttribute('data-product-id') || '',
          offsetFromTop: topVisible.offsetFromTop,
        };
      }
      var payload = {
        url: key,
        html: grid.outerHTML,
        nextUrl: grid.getAttribute('data-next-url') || '',
        scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
        anchor: anchor,
        ts: Date.now(),
      };
      sessionStorage.setItem(GRID_RESTORE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function revealAfterRestore() {
    // Drop the hidden-while-restoring class on next paint
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.remove('capon-restoring');
      });
    });
  }

  // Scroll to either the anchor card or the pixel Y, with iOS-Safari-friendly retries
  function applyScrollTarget(data) {
    var targetY = data.scrollY || 0;
    function jump() {
      // Prefer anchor: find the saved card and scroll it into the same screen position
      if (data.anchor && (data.anchor.handle || data.anchor.id)) {
        var sel = data.anchor.handle
          ? '[data-product-card][data-product-handle="' + cssEscape(data.anchor.handle) + '"]'
          : '[data-product-card][data-product-id="' + cssEscape(data.anchor.id) + '"]';
        var card = document.querySelector(sel);
        if (card) {
          var rect = card.getBoundingClientRect();
          var offset = data.anchor.offsetFromTop || 0;
          var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
          var newY = currentY + rect.top - offset;
          window.scrollTo(0, newY);
          return;
        }
      }
      window.scrollTo(0, targetY);
    }
    // First jump (synchronous, before reveal)
    jump();
    // Re-apply across layout settles (image loads, address bar changes, font swaps)
    var tries = 0;
    (function nudge() {
      jump();
      tries++;
      if (tries < 8) setTimeout(nudge, 60 * tries);
    })();
    // Also re-apply on load + when all images finish (mobile Safari often shifts layout late)
    window.addEventListener('load', jump, { once: true });
  }

  // Minimal CSS.escape polyfill for older Safari
  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) {
      return '\\' + ch;
    });
  }

  function tryRestoreGridState() {
    try {
      var raw = sessionStorage.getItem(GRID_RESTORE_KEY);
      if (!raw) { revealAfterRestore(); return false; }
      var data = JSON.parse(raw);
      var key = window.location.pathname + window.location.search;
      if (!data || data.url !== key) { revealAfterRestore(); return false; }
      if (Date.now() - (data.ts || 0) > GRID_RESTORE_TTL_MS) {
        sessionStorage.removeItem(GRID_RESTORE_KEY);
        revealAfterRestore();
        return false;
      }
      var grid = document.querySelector('[data-product-grid]');
      if (!grid) { revealAfterRestore(); return false; }
      // Replace grid with cached HTML
      var tmp = document.createElement('div');
      tmp.innerHTML = data.html;
      var restored = tmp.firstElementChild;
      if (!restored) { revealAfterRestore(); return false; }
      grid.replaceWith(restored);
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      applyScrollTarget(data);
      revealAfterRestore();
      // Keep the snapshot until we know restoration stuck — clear on next pagehide instead
      return true;
    } catch (e) {
      revealAfterRestore();
      return false;
    }
  }

  // Handle bfcache restores (iOS Safari & modern browsers): DOMContentLoaded does NOT fire,
  // so we must do restoration work in pageshow.
  function onPageShow(event) {
    // Always make sure the page is visible — bfcache may have preserved the hidden class
    document.documentElement.classList.remove('capon-restoring');
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    if (!event.persisted) return; // fresh load — DOMContentLoaded path handles it

    // bfcache hit: DOM is the previous DOM. Safari may have reset scroll to 0 — re-apply.
    try {
      var raw = sessionStorage.getItem(GRID_RESTORE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      var key = window.location.pathname + window.location.search;
      if (!data || data.url !== key) return;
      // Only re-apply if scroll was reset
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(currentY - (data.scrollY || 0)) > 40) {
        applyScrollTarget(data);
      }
    } catch (e) {}
  }

  function initGridScrollRestore() {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    // Capture product card link clicks anywhere on the page (works even after AJAX grid replacement)
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('[data-product-grid] [data-product-card] a[href]');
      if (!link) return;
      if (link.closest('[data-quick-view-open], [data-wishlist-toggle]')) return;
      saveGridState();
    }, true);

    // Save on every page-hide too (covers some Safari edge cases where click handler doesn't fire in time)
    window.addEventListener('pagehide', function () {
      if (document.querySelector('[data-product-grid]')) saveGridState();
    });

    // pageshow handles bfcache restores (always fires, even when DOMContentLoaded doesn't)
    window.addEventListener('pageshow', onPageShow);

    // Initial restore on fresh load
    tryRestoreGridState();
  }

  function initInfiniteScroll() {
    var grid = document.querySelector('[data-product-grid]');
    var sentinel = document.querySelector('[data-infinite-sentinel]');
    if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

    var fallback = document.querySelector('[data-infinite-fallback]');
    var loading = document.querySelector('[data-infinite-loading]');
    var debugShown = document.querySelector('[data-collection-debug-shown]');
    if (fallback) fallback.style.display = 'none';

    function updateDebugCount() {
      if (!debugShown) return;
      debugShown.textContent = grid.children.length;
    }

    var isLoading = false;
    var prefetchCache = Object.create(null);

    function prefetch(url) {
      if (!url || prefetchCache[url]) return;
      prefetchCache[url] = fetch(url).then(function (r) {
        return r.ok ? r.text() : null;
      }).catch(function () { return null; });
    }

    async function loadNext() {
      var nextUrl = grid.getAttribute('data-next-url');
      if (!nextUrl || isLoading) return;
      isLoading = true;
      if (loading) loading.hidden = false;

      try {
        // Use prefetched response if available — instant, otherwise fetch now
        var htmlPromise = prefetchCache[nextUrl] || fetch(nextUrl).then(function (r) {
          if (!r.ok) throw new Error('Fetch failed: ' + r.status);
          return r.text();
        });
        var html = await htmlPromise;
        if (!html) throw new Error('Empty response');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-product-grid]');
        if (!nextGrid) throw new Error('No grid in next page');

        var fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach(function (child) {
          fragment.appendChild(child);
        });
        grid.appendChild(fragment);
        updateDebugCount();
        // The appended cards are brand new DOM: bind their carousels, repaint wishlist
        // hearts, and keep the client-side date sort correct across page boundaries.
        initProductCardCarousel();
        refreshWishlistButtons();
        applyClientSideDateSort();

        var newNext = nextGrid.getAttribute('data-next-url');
        if (newNext) {
          grid.setAttribute('data-next-url', newNext);
          // Start fetching the next-next page right now so the upcoming load is instant
          prefetch(newNext);
          observer.unobserve(sentinel);
          requestAnimationFrame(function () {
            observer.observe(sentinel);
            // If user already scrolled past the lookahead, chain another load
            var rect = sentinel.getBoundingClientRect();
            if (rect.top < window.innerHeight + lookahead) loadNext();
          });
        } else {
          grid.removeAttribute('data-next-url');
          observer.disconnect();
          sentinel.remove();
        }
      } catch (err) {
        console.error(err);
        observer.disconnect();
        // display:'' undoes the style.display='none' from init — with only hidden=false the
        // pagination stayed invisible and a failed load left no way to reach further pages.
        if (fallback) { fallback.hidden = false; fallback.style.display = ''; }
      } finally {
        isLoading = false;
        if (loading) loading.hidden = true;
      }
    }

    // Lookahead = 5 screens — start loading well before user reaches the bottom
    var lookahead = Math.max(window.innerHeight * 5, 3500);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNext();
      });
    }, { rootMargin: lookahead + 'px 0px' });

    observer.observe(sentinel);

    // Prefetch page 2 immediately so the first load is instant
    var firstNext = grid.getAttribute('data-next-url');
    if (firstNext) prefetch(firstNext);
  }

  // Recently viewed: store / retrieve product info in localStorage
  var RECENT_KEY = 'capon:recently-viewed';
  var RECENT_MAX = 8;

  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (e) { return []; }
  }

  function setRecent(items) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(items)); } catch (e) {}
  }

  function recordRecentFromPage() {
    var el = document.querySelector('[data-product-recent]');
    if (!el) return;
    try {
      var product = JSON.parse(el.textContent);
      if (!product || !product.id) return;
      var items = getRecent().filter(function (p) { return p.id !== product.id; });
      items.unshift(product);
      setRecent(items.slice(0, RECENT_MAX));
    } catch (e) {}
  }

  // Shopify JSON (product/collection endpoints): featured_image may be a string or an object with src/url.
  function jsonProductImageSrc(p) {
    if (!p) return '';
    function fromImageField(f) {
      if (!f) return '';
      if (typeof f === 'string') return f;
      if (typeof f === 'object' && f.src) return f.src;
      if (typeof f === 'object' && f.url) return f.url;
      return '';
    }
    var src = fromImageField(p.featured_image);
    if (src) return src;
    if (typeof p.image === 'string' && p.image) return p.image;
    if (p.images && p.images[0]) {
      var im = p.images[0];
      return typeof im === 'string' ? im : fromImageField(im);
    }
    return '';
  }

  function normalizeShopifyImgUrl(src) {
    if (!src || typeof src !== 'string') return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function renderCard(p) {
    var img = p.image
      ? '<img src="' + p.image + '" alt="" loading="lazy" decoding="async" width="200" height="200">'
      : '<div class="search-modal__card-placeholder"></div>';
    var badges = '';
    if (p.discount_percent && p.discount_percent > 0) {
      badges += '<span class="search-modal__badge search-modal__badge--sale">-' + p.discount_percent + '%</span>';
    } else if (p.on_sale) {
      badges += '<span class="search-modal__badge search-modal__badge--sale">Sale</span>';
    }
    if (p.labels && p.labels.length) {
      for (var li = 0; li < p.labels.length; li++) {
        var l = p.labels[li] || {};
        badges += '<span class="search-modal__badge search-modal__badge--label"' +
          ' style="background:' + (l.bg || '#000') + ';color:' + (l.fg || '#fff') + ';' +
          (li > 0 ? 'top:' + (6 + li * 22) + 'px;' : '') + '">' +
          escapeHtml(l.text || '') + '</span>';
      }
    }
    return (
      '<a class="search-modal__card" href="' + p.url + '">' +
        '<div class="search-modal__card-media">' + badges + img + '</div>' +
        '<div class="search-modal__card-title">' + p.title + '</div>' +
        (p.price ? '<div class="search-modal__card-price">' + p.price + '</div>' : '') +
      '</a>'
    );
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlightQuery(text, q) {
    var safe = escapeHtml(text);
    if (!q) return safe;
    var rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    return safe.replace(rx, '<strong>$1</strong>');
  }

  // Search modal
  function initSearchModal() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var input = modal.querySelector('[data-search-input]');
    var queriesSection = modal.querySelector('[data-search-queries]');
    var queriesList = modal.querySelector('[data-search-queries-list]');
    var recentSection = modal.querySelector('[data-search-recent]');
    var recentGrid = modal.querySelector('[data-search-recent-grid]');
    var resultsSection = modal.querySelector('[data-search-results]');
    var resultsGrid = modal.querySelector('[data-search-results-grid]');
    var collectionsSection = modal.querySelector('[data-search-collections]');
    var collectionsList = modal.querySelector('[data-search-collections-list]');
    var emptyMsg = modal.querySelector('[data-search-empty]');
    var viewAllWrap = modal.querySelector('[data-search-view-all-wrap]');
    var viewAllLink = modal.querySelector('[data-search-view-all]');
    var clearBtn = modal.querySelector('[data-search-clear-recent]');

    function renderRecent() {
      var items = getRecent();
      if (items.length === 0) {
        recentSection.hidden = true;
        return;
      }
      recentGrid.innerHTML = items.map(renderCard).join('');
      recentSection.hidden = false;
    }

    function open() {
      renderRecent();
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.classList.add('drawer-open');
      setTimeout(function () { input.focus(); }, 50);
      document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      setTimeout(function () { modal.hidden = true; }, 200);
      document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    clearBtn.addEventListener('click', function () {
      setRecent([]);
      renderRecent();
    });

    var debounceTimer = null;
    var currentController = null;
    var searchCache = Object.create(null);
    var SEARCH_CACHE_MAX = 30;
    var searchCacheOrder = [];

    function cachePut(q, data) {
      if (!searchCache[q]) searchCacheOrder.push(q);
      searchCache[q] = data;
      while (searchCacheOrder.length > SEARCH_CACHE_MAX) {
        var oldest = searchCacheOrder.shift();
        delete searchCache[oldest];
      }
    }

    function resetResults() {
      queriesSection.hidden = true;
      resultsSection.hidden = true;
      collectionsSection.hidden = true;
      emptyMsg.hidden = true;
      viewAllWrap.hidden = true;
      renderRecent();
    }

    // Warm the connection on modal open so the first real request skips TLS/DNS
    var warmed = false;
    function warmSearch() {
      if (warmed) return;
      warmed = true;
      try { fetch('/search/suggest.json?q=&resources[limit]=1', { priority: 'low' }).catch(function(){}); } catch (e) {}
    }
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('mouseenter', warmSearch, { once: true });
      btn.addEventListener('focus', warmSearch, { once: true });
    });
    if (input) input.addEventListener('focus', warmSearch, { once: true });

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (!q) {
        resetResults();
        return;
      }
      recentSection.hidden = true;
      // Instant render from cache if we've seen this query before
      if (searchCache[q]) {
        renderSearchResults(q, searchCache[q].suggestData, searchCache[q].fullData);
        // Re-fetch in background to refresh, but no need to wait
        debounceTimer = setTimeout(function () { runSearch(q); }, 250);
        return;
      }
      debounceTimer = setTimeout(function () { runSearch(q); }, 80);
    });

    function renderSearchResults(q, suggestData, fullData) {
      var suggestResults = (suggestData.resources && suggestData.resources.results) || {};
      var products = (fullData.products || []).slice(0, 8);
      var queries = suggestResults.queries || [];
      var collections = suggestResults.collections || [];

      if (queries.length > 0) {
        queriesList.innerHTML = queries.map(function (qq) {
          var text = qq.text || qq.title || '';
          return '<button type="button" class="search-modal__chip" data-search-chip="'
            + escapeHtml(text) + '">' + highlightQuery(text, q) + '</button>';
        }).join('');
        queriesSection.hidden = false;
      } else {
        queriesSection.hidden = true;
      }

      if (products.length > 0) {
        resultsGrid.innerHTML = products.map(renderCard).join('');
        resultsSection.hidden = false;
      } else {
        resultsSection.hidden = true;
      }

      if (collections.length > 0) {
        collectionsList.innerHTML = collections.map(function (c) {
          var m = (c.url || '').match(/\/collections\/([^/?#]+)/);
          var handle = m ? m[1] : '';
          var count = c.products_count != null ? c.products_count
            : (c.product_count != null ? c.product_count
              : (c.count != null ? c.count : null));
          return (
            '<a class="search-modal__collection" href="' + c.url + '" data-collection-handle="' + escapeHtml(handle) + '">' +
              '<div class="search-modal__collection-thumbs" data-collection-thumbs>' +
                '<div class="search-modal__collection-thumb"></div>' +
                '<div class="search-modal__collection-thumb"></div>' +
                '<div class="search-modal__collection-thumb"></div>' +
                '<div class="search-modal__collection-thumb"></div>' +
              '</div>' +
              '<div class="search-modal__collection-info">' +
                '<div class="search-modal__collection-title">' + escapeHtml(c.title) + '</div>' +
                '<div class="search-modal__collection-count" data-collection-count>' +
                  (count != null ? count + ' products' : '') +
                '</div>' +
              '</div>' +
            '</a>'
          );
        }).join('');
        collectionsSection.hidden = false;

        collectionsList.querySelectorAll('[data-collection-handle]').forEach(async function (card) {
          var handle = card.getAttribute('data-collection-handle');
          if (!handle) return;
          try {
            var r = await fetch('/collections/' + handle + '/products.json?limit=4');
            if (!r.ok) return;
            var d = await r.json();
            var items = d.products || [];
            var thumbs = card.querySelectorAll('.search-modal__collection-thumb');
            items.slice(0, 4).forEach(function (p, i) {
              var src = normalizeShopifyImgUrl(jsonProductImageSrc(p));
              if (src && thumbs[i]) {
                thumbs[i].innerHTML = '<img src="' + escapeHtml(src) + '" alt="" loading="lazy">';
              }
            });
          } catch (e) {}
        });
      } else {
        collectionsSection.hidden = true;
      }

      var hasAnything = products.length || queries.length || collections.length;
      emptyMsg.hidden = !!hasAnything;
      viewAllLink.setAttribute('href', '/search?q=' + encodeURIComponent(q));
      viewAllWrap.hidden = !hasAnything;
    }

    async function runSearch(q) {
      if (currentController) currentController.abort();
      currentController = new AbortController();
      try {
        var suggestUrl = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=query,collection'
          + '&resources[limit]=10';
        var fullUrl = '/search?view=suggestions&type=product&q=' + encodeURIComponent(q);

        var [suggestRes, fullRes] = await Promise.all([
          fetch(suggestUrl, { signal: currentController.signal }),
          fetch(fullUrl, { signal: currentController.signal })
        ]);
        if (!suggestRes.ok) throw new Error('suggest failed');
        if (!fullRes.ok) throw new Error('search failed');

        var suggestData = await suggestRes.json();
        var fullData = await fullRes.json();

        cachePut(q, { suggestData: suggestData, fullData: fullData });
        renderSearchResults(q, suggestData, fullData);
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error(err);
      }
    }

    queriesList.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-search-chip]');
      if (!chip) return;
      input.value = chip.getAttribute('data-search-chip');
      runSearch(input.value);
      input.focus();
    });
  }

  // Slideshow
  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-slideshow-slide]');
      if (slides.length <= 1) return;

      var dots = root.querySelectorAll('[data-slideshow-dot]');
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var current = 0;
      var timer = null;

      function go(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          if (idx === current) s.setAttribute('data-active', ''); else s.removeAttribute('data-active');
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === current);
        });
      }

      function next() { go(current + 1); }
      function prev() { go(current - 1); }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(next, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prevBtn = root.querySelector('[data-slideshow-prev]');
      var nextBtn = root.querySelector('[data-slideshow-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-slideshow-dot'), 10));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      start();
    });
  }

  // Hero parallax
  function initHeroParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroes = document.querySelectorAll('.hero--parallax');
    if (!heroes.length) return;

    function onScroll() {
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        var media = hero.querySelector('[data-hero-media]');
        if (!media) return;
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = rect.top * -0.25;
        media.style.transform = 'translateY(' + offset + 'px)';
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    onScroll();
  }

  // Transparent header
  function applyTransparentHeader() {
    var header = document.querySelector('[data-header]') || document.querySelector('.site-header');
    if (!header) return;
    var main = document.querySelector('main');
    if (!main) return;
    var firstSection = main.firstElementChild;
    if (!firstSection) {
      header.classList.remove('site-header--transparent', 'site-header--scrolled');
      return;
    }
    // Check the wrapper itself AND its descendants for the flag
    var hasTransparent =
      firstSection.matches && firstSection.matches('[data-transparent-header]') ? true :
      firstSection.querySelector('[data-transparent-header]') ? true : false;

    if (hasTransparent) {
      header.classList.add('site-header--transparent');
      // Push header below the announcement bar (if visible)
      var bar = document.querySelector('[data-announcement-bar]:not([hidden])');
      var offset = bar ? bar.offsetHeight : 0;
      header.style.setProperty('--header-offset-top', offset + 'px');
    } else {
      header.classList.remove('site-header--transparent', 'site-header--scrolled');
      header.style.removeProperty('--header-offset-top');
    }
  }

  function initTransparentHeader() {
    applyTransparentHeader();

    var header = document.querySelector('[data-header]') || document.querySelector('.site-header');
    if (!header) return;

    function onScroll() {
      if (!header.classList.contains('site-header--transparent')) return;
      var threshold = header.offsetHeight || 60;
      if (window.scrollY > threshold) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    onScroll();

    // Re-evaluate when theme editor reloads sections
    document.addEventListener('shopify:section:load', applyTransparentHeader);
    document.addEventListener('shopify:section:unload', applyTransparentHeader);
  }

  // Announcement bar
  var ANNOUNCE_KEY = 'capon:announcement-dismissed-until';
  function initAnnouncementBar() {
    document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
      var dismissable = bar.getAttribute('data-dismissable') === 'true';
      if (dismissable) {
        var until = parseInt(localStorage.getItem(ANNOUNCE_KEY) || '0', 10);
        if (Date.now() < until) return;
      }
      bar.hidden = false;

      var messages = bar.querySelectorAll('[data-announcement-message]');
      var autorotate = bar.getAttribute('data-autorotate') === 'true';
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;

      if (messages.length > 1 && autorotate) {
        var i = 0;
        setInterval(function () {
          messages[i].removeAttribute('data-active');
          i = (i + 1) % messages.length;
          messages[i].setAttribute('data-active', '');
        }, interval);
      }

      var close = bar.querySelector('[data-announcement-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          try {
            localStorage.setItem(ANNOUNCE_KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
          } catch (e) {}
        });
      }
    });
  }

  // Countdown
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (root) {
      var target = new Date(root.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var d = root.querySelector('[data-countdown-d]');
      var h = root.querySelector('[data-countdown-h]');
      var m = root.querySelector('[data-countdown-m]');
      var s = root.querySelector('[data-countdown-s]');
      var expired = root.querySelector('[data-countdown-expired]');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (d) d.textContent = '00';
          if (h) h.textContent = '00';
          if (m) m.textContent = '00';
          if (s) s.textContent = '00';
          if (expired) expired.hidden = false;
          clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  // Recently viewed section hydration
  function initRecentlyViewedSection() {
    var section = document.querySelector('[data-recently-viewed-section]');
    if (!section) return;
    var grid = section.querySelector('[data-recently-viewed-grid]');
    var items = getRecent();
    if (!items.length) return;
    grid.innerHTML = items.map(function (p) {
      var img = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy">'
        : '';
      return (
        '<a class="recently-viewed__card" href="' + p.url + '">' +
          '<div class="recently-viewed__card-media">' + img + '</div>' +
          '<div class="recently-viewed__card-title">' + p.title + '</div>' +
          (p.price ? '<div class="recently-viewed__card-price">' + p.price + '</div>' : '') +
        '</a>'
      );
    }).join('');
    section.hidden = false;
  }

  /**
   * Shopify injects / refreshes the “Buy it now” button after theme CSS; external
   * wallet styles can override base.css. Inline !important beats those stylesheets.
   */
  function initDynamicCheckoutButtonFix() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var form = section.querySelector('#ProductForm') || section.querySelector('[data-pdp-form]');
    if (!form) return;

    function fixUnbrandedBuyItNow() {
      form.querySelectorAll('button.shopify-payment-button__button--unbranded').forEach(function (btn) {
        btn.style.setProperty('-webkit-appearance', 'none', 'important');
        btn.style.setProperty('appearance', 'none', 'important');
        btn.style.setProperty('box-sizing', 'border-box', 'important');
        btn.style.setProperty('display', 'flex', 'important');
        btn.style.setProperty('align-items', 'center', 'important');
        btn.style.setProperty('justify-content', 'center', 'important');
        btn.style.setProperty('width', '100%', 'important');
        btn.style.setProperty('min-height', '52px', 'important');
        btn.style.setProperty('height', '52px', 'important');
        btn.style.setProperty('padding', '0 20px', 'important');
        btn.style.setProperty('line-height', '1.25', 'important');
        btn.style.setProperty('font-family', "'Quantico', system-ui, -apple-system, sans-serif", 'important');
        btn.style.setProperty('font-weight', '700', 'important');
        btn.style.setProperty('letter-spacing', '0.05em', 'important');
      });
    }

    var debounceTimer;
    function scheduleFix() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fixUnbrandedBuyItNow, 40);
    }

    fixUnbrandedBuyItNow();
    [120, 450, 1500].forEach(function (ms) {
      setTimeout(fixUnbrandedBuyItNow, ms);
    });

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(scheduleFix);
      mo.observe(form, { childList: true, subtree: true });
    }
  }

  // Product page: gallery, variant selection, quantity
  function initProductPage() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var gallery = section.querySelector('[data-pdp-gallery]');
    var scroller = gallery && gallery.querySelector('[data-pdp-scroller]');
    var slides = scroller ? scroller.querySelectorAll('[data-pdp-slide]') : [];
    var thumbs = section.querySelectorAll('[data-pdp-thumb]');
    var dots = section.querySelectorAll('[data-pdp-dot]');

    function scrollToIndex(idx) {
      if (!scroller || !slides[idx]) return;
      scroller.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    }

    function setActive(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-slide-index'), 10) || 0;
        scrollToIndex(idx);
        setActive(idx);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-slide-index'), 10) || 0;
        scrollToIndex(idx);
        setActive(idx);
      });
    });

    if (scroller && slides.length) {
      var scrollTimer;
      scroller.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(scroller.scrollLeft / scroller.clientWidth);
          if (idx >= 0 && idx < slides.length) setActive(idx);
        }, 80);
      }, { passive: true });
    }

    // Quantity +/-
    var qtyInput = section.querySelector('[data-pdp-qty-input]');
    section.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-pdp-qty'), 10);
        var current = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = Math.max(1, current + delta);
      });
    });

    // Variant selection
    var variantsScript = section.querySelector('[data-pdp-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var variantInput = section.querySelector('[data-pdp-variant-id]');
    var priceContainer = section.querySelector('[data-pdp-price]');
    var atcBtn = section.querySelector('[data-pdp-atc]');
    var atcText = section.querySelector('[data-pdp-atc-text]');
    var pdpForm = section.querySelector('[data-pdp-form]');
    if (atcBtn && pdpForm) {
      atcBtn.addEventListener('pointerdown', function () {
        pdpForm._caponNotifyAnchor = null;
      }, true);
    }

    function updateOptionLabels() {
      section.querySelectorAll('[data-pdp-option]').forEach(function (opt) {
        var checked = opt.querySelector('input[data-pdp-option-input]:checked');
        var valueLabel = opt.querySelector('[data-pdp-option-value]');
        if (checked && valueLabel) valueLabel.textContent = checked.value;
        opt.querySelectorAll('.pdp-option__chip').forEach(function (chip) {
          chip.classList.toggle('is-selected', chip.contains(checked));
        });
      });
    }

    function getSelectedOptions() {
      var selected = [];
      section.querySelectorAll('[data-pdp-option]').forEach(function (opt) {
        var checked = opt.querySelector('input[data-pdp-option-input]:checked');
        if (checked) selected.push(checked.value);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    async function fetchProductFragment(variantId) {
      try {
        var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + section.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');
        var res = await fetch(url);
        if (!res.ok) return;
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPrice = doc.querySelector('[data-pdp-price]');
        if (newPrice && priceContainer) priceContainer.innerHTML = newPrice.innerHTML;
      } catch (e) {}
    }

    section.querySelectorAll('input[data-pdp-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateOptionLabels();
        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (!variant) {
          if (atcBtn) atcBtn.disabled = true;
          if (atcText) atcText.textContent = 'Unavailable';
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (atcBtn) atcBtn.disabled = !variant.available;
        if (atcText) atcText.textContent = variant.available ? 'Add to cart' : 'Sold out';

        // Scroll the gallery to the variant's featured image (if it's one of the product images)
        if (variant.featured_image && slides.length) {
          var targetId = String(variant.featured_image.id);
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-image-id') === targetId) {
              scrollToIndex(i);
              setActive(i);
              break;
            }
          }
        }

        // Update URL without reload
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        // Update price from server (handles compare-at, sale, etc.)
        fetchProductFragment(variant.id);
      });
    });

    // Sticky add-to-cart bar — show when main ATC scrolls out of view
    var stickyBar = document.querySelector('[data-pdp-sticky]');
    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show sticky when main ATC is NOT intersecting AND has scrolled past the top
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { rootMargin: '0px 0px 0px 0px' });
      observer.observe(atcBtn);

      var stickyAtc = stickyBar.querySelector('[data-pdp-sticky-atc]');
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          var form = section.querySelector('[data-pdp-form]');
          if (form) {
            form._caponNotifyAnchor = stickyAtc;
            var submitter = form.querySelector('[data-pdp-atc]');
            form.requestSubmit ? form.requestSubmit(submitter) : form.submit();
          }
        });
      }
    }
  }

  // Related products (lazy-load via Section Rendering API)
  async function initRelatedProducts() {
    var section = document.querySelector('[data-related-products]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    if (!url) return;

    try {
      var res = await fetch(url);
      if (!res.ok) return;
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('[data-related-products]');
      if (!newSection) {
        section.style.display = 'none';
        return;
      }
      // Replace inner content but keep wrapper attributes
      section.innerHTML = newSection.innerHTML;
      if (!section.querySelector('.product-card')) {
        section.style.display = 'none';
      }
    } catch (e) {
      section.style.display = 'none';
    }
  }

  // ============ Dropdown click trigger ============
  function initDropdownClick() {
    var header = document.querySelector('.site-header--dropdown-click');
    if (!header) return;
    header.querySelectorAll('.site-nav__item--has-dropdown > .site-nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var item = link.parentElement;
        if (window.matchMedia('(min-width: 990px)').matches) {
          e.preventDefault();
          header.querySelectorAll('.site-nav__item--has-dropdown.is-open').forEach(function (other) {
            if (other !== item) other.classList.remove('is-open');
          });
          item.classList.toggle('is-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-nav__item--has-dropdown')) {
        header.querySelectorAll('.site-nav__item--has-dropdown.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      }
    });
  }

  // ============ Locale form auto-submit ============
  function initLocaleForm() {
    document.querySelectorAll('.site-header__locale-form select').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  // ============ Announcement bar countdown ============
  function initAnnouncementCountdown() {
    document.querySelectorAll('[data-ab-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-ab-countdown')).getTime();
      if (isNaN(target)) return;
      var text = el.querySelector('[data-ab-countdown-text]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { text.textContent = '00:00:00'; clearInterval(timer); return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        text.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  // ============ Compare count badge ============
  var COMPARE_KEY = 'capon:compare';
  function updateCompareCount() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(COMPARE_KEY)) || []; } catch (e) {}
    document.querySelectorAll('[data-compare-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  // ============ Sticky header: hide on scroll down, show on scroll up ============
  function initStickyHeaderOnScrollUp() {
    var header = document.querySelector('[data-header][data-sticky-type="on-scroll-up"]');
    if (!header) return;
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var goingDown = y > lastY && y > header.offsetHeight;
      header.classList.toggle('is-hidden', goingDown);
      lastY = y;
    }, { passive: true });
  }

  // ============ Wishlist header badge ============
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // ============ Back to top ============
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    btn.hidden = false;
    function onScroll() {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }

  // ============ Cookie banner ============
  var COOKIE_KEY = 'capon:cookie-decision';
  function initCookieBanner() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    if (localStorage.getItem(COOKIE_KEY)) return;
    banner.hidden = false;
    function decide(value) {
      try { localStorage.setItem(COOKIE_KEY, value); } catch (e) {}
      banner.hidden = true;
    }
    banner.querySelector('[data-cookie-accept]').addEventListener('click', function () { decide('accepted'); });
    banner.querySelector('[data-cookie-decline]').addEventListener('click', function () { decide('declined'); });
  }

  // ============ Newsletter popup ============
  var NL_POPUP_KEY = 'capon:newsletter-popup-seen';
  function initNewsletterPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;
    if (localStorage.getItem(NL_POPUP_KEY)) return;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 15000;
    setTimeout(function () { popup.hidden = false; }, delay);
    popup.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.hidden = true;
        try { localStorage.setItem(NL_POPUP_KEY, '1'); } catch (e) {}
      });
    });
  }

  // ============ Shipping ETA ============
  function initShippingEta() {
    var el = document.querySelector('[data-pdp-shipping-text]');
    var config = document.querySelector('[data-pdp-shipping-config]');
    if (!el || !config) return;
    try {
      var cfg = JSON.parse(config.textContent);
      var now = new Date();
      var min = new Date(now); min.setDate(now.getDate() + cfg.minDays);
      var max = new Date(now); max.setDate(now.getDate() + cfg.maxDays);
      var opts = { weekday: 'short', month: 'short', day: 'numeric' };
      el.textContent = 'Get it ' + min.toLocaleDateString(undefined, opts) + ' – ' + max.toLocaleDateString(undefined, opts);
    } catch (e) {}
  }

  // ============ Wishlist ============
  var WISHLIST_KEY = 'capon:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function initWishlist() {
    // Single implementation lives at module scope so filter swaps and infinite scroll can
    // repaint new cards too.
    var updateButtons = refreshWishlistButtons;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle); else list.splice(idx, 1);
      setWishlist(list);
      updateButtons();
      updateWishlistCount();
    });
    updateButtons();
    updateWishlistCount();
  }

  // ============ Quick view modal ============
  function initQuickView() {
    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-quick-view-body]');

    function open() {
      modal.hidden = false;
      document.body.classList.add('drawer-open');
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('drawer-open');
      body.innerHTML = '<p class="quick-view__loading">Loading…</p>';
    }

    modal.querySelectorAll('[data-quick-view-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    document.addEventListener('click', async function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      open();
      try {
        var res = await fetch('/products/' + handle + '.js');
        if (!res.ok) throw new Error('fetch failed');
        var p = await res.json();
        var imgSrc = normalizeShopifyImgUrl(jsonProductImageSrc(p));
        var img = imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '">' : '';
        body.innerHTML =
          '<div class="quick-view__product">' +
            '<div class="quick-view__image">' + img + '</div>' +
            '<div class="quick-view__info">' +
              '<h2 class="quick-view__title">' + p.title + '</h2>' +
              '<div class="quick-view__price">' + formatMoney(p.price) + '</div>' +
              '<p>' + (p.description ? p.description.replace(/<[^>]+>/g, '').slice(0, 200) + '…' : '') + '</p>' +
              '<a href="' + p.url + '" class="quick-view__view-full">View full details →</a>' +
            '</div>' +
          '</div>';
      } catch (err) {
        body.innerHTML = '<p style="text-align:center;padding:40px;">Could not load product.</p>';
      }
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return amount;
  }

  // ============ Collection filters & sort ============
  // Re-paint the saved state on wishlist hearts. The toggle click itself is document-delegated
  // and survives DOM swaps, but the is-saved class is painted per element — cards that arrive
  // later (filtering, infinite scroll) need a repaint or saved items render as unsaved.
  function refreshWishlistButtons() {
    var saved = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-saved', saved.indexOf(btn.getAttribute('data-product-handle')) !== -1);
    });
  }

  // Filtering rewrites history via pushState, so Back/Forward change the URL without touching
  // the DOM — the page would show filtered results under an unfiltered URL (or vice versa).
  // Reload so the server renders whatever the restored URL says. Guarded against Safari's
  // load-time popstate by only acting when the URL differs from the one currently rendered.
  var filtersRenderedUrl = window.location.href;
  window.addEventListener('popstate', function () {
    if (!document.querySelector('[data-collection-toolbar]')) return;
    if (window.location.href === filtersRenderedUrl) return;
    window.location.reload();
  });

  // Monotonic token so a slow response from an earlier filter click can never overwrite the
  // results of a later one (rapid checkbox clicking = concurrent fetches, order not guaranteed).
  var filtersRequestSeq = 0;

  // Search supports only relevance + price sort server-side.
  // For 'created-descending' / 'created-ascending' we sort the loaded cards client-side.
  // Module-level (not inside initCollectionFilters) so infinite scroll can re-run it after
  // appending pages — otherwise later pages arrive unsorted under a date sort.
  function applyClientSideDateSort() {
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort_by');
    if (sort !== 'created-descending' && sort !== 'created-ascending') return;
    var gridNow = document.querySelector('[data-product-grid]');
    if (!gridNow) return;
    var cards = Array.from(gridNow.querySelectorAll('[data-product-card]'));
    if (cards.length < 2) return;
    cards.sort(function (a, b) {
      var ax = parseInt(a.getAttribute('data-product-created') || '0', 10);
      var bx = parseInt(b.getAttribute('data-product-created') || '0', 10);
      return sort === 'created-descending' ? bx - ax : ax - bx;
    });
    // Reorder DOM. Each card's parent is the grid cell, not the card itself —
    // walk up until we find a direct child of gridNow.
    cards.forEach(function (card) {
      var node = card;
      while (node.parentElement && node.parentElement !== gridNow) node = node.parentElement;
      if (node.parentElement === gridNow) gridNow.appendChild(node);
    });
  }

  // Set when filter results were refreshed while the mobile filter drawer was open: the
  // drawer's body.drawer-open scroll lock makes the viewport unscrollable, so the jump to
  // the top of the new results must wait until the drawer closes. Lives OUTSIDE
  // initCollectionFilters because each applyUrl re-runs it, and the close handler that
  // consumes the flag belongs to a newer generation than the applyUrl that set it.
  var filtersPendingScroll = false;

  // Instant jump regardless of the theme's html.smooth-scroll CSS: behavior 'auto' defers
  // to CSS (= smooth here), so it must be explicitly 'instant'.
  function scrollResultsToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  function initCollectionFilters() {
    var toolbar = document.querySelector('[data-collection-toolbar]');
    if (!toolbar) return;

    var filtersPanel = document.querySelector('[data-collection-filters]');
    var openBtn = document.querySelector('[data-filters-open]');
    var grid = document.querySelector('[data-product-grid]');
    var sortSelect = document.querySelector('[data-sort-select]');
    var filtersForm = document.querySelector('[data-filters-form]');

    if (openBtn && filtersPanel) {
      openBtn.addEventListener('click', function () {
        filtersPanel.hidden = false;
        requestAnimationFrame(function () { filtersPanel.classList.add('is-open'); });
        document.body.classList.add('drawer-open');
        // A pending scroll from a previous drawer session must not fire on THIS session's
        // close — the user has re-opened the drawer and is starting a new interaction.
        filtersPendingScroll = false;
      });
      filtersPanel.querySelectorAll('[data-filters-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          filtersPanel.classList.remove('is-open');
          document.body.classList.remove('drawer-open');
          setTimeout(function () { filtersPanel.hidden = true; }, 250);
          // Results changed while the drawer was open and the scroll lock swallowed the
          // jump — the lock is off now, so land the user at the top of the new results.
          if (filtersPendingScroll) {
            filtersPendingScroll = false;
            scrollResultsToTop();
          }
        });
      });
    }

    async function applyUrl(url) {
      var seq = ++filtersRequestSeq;
      // Captured BEFORE the panel is replaced (which destroys focus): are they mid-typing
      // in a price field? If so, skip the scroll-to-top and restore their focus afterwards.
      var typing = (function () {
        var ae = document.activeElement;
        if (!(ae && filtersForm && filtersForm.contains(ae) && (ae.type === 'number' || ae.type === 'text'))) return null;
        return { name: ae.getAttribute('name'), value: ae.value };
      })();
      try {
        var res = await fetch(url);
        if (!res.ok) return;
        var html = await res.text();
        if (seq !== filtersRequestSeq) return; // superseded by a newer filter click
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPanel = doc.querySelector('[data-collection-filters]');
        var newMain = doc.querySelector('.collection__main');
        var curMain = document.querySelector('.collection__main');
        if (newMain && curMain) {
          // Swap the ENTIRE results area — grid, infinite-scroll sentinel, loading indicator,
          // pagination AND toolbar — not just the grid. The grid-only swap left the sentinel
          // and pagination belonging to the PREVIOUS result set, so filtered results loaded
          // one page and then starved (stale or already-removed sentinel), and every swap
          // stacked another IntersectionObserver generation with dead references. Replacing
          // the sentinel node also detaches all observers from older generations, and the
          // fresh toolbar drops stacked sort listeners.
          curMain.replaceWith(newMain);
        } else {
          // Unrecognised page structure — fall back to the old grid-only swap.
          var newGrid = doc.querySelector('[data-product-grid]');
          var newCount = doc.querySelector('.collection-toolbar__count');
          if (newGrid && grid) grid.replaceWith(newGrid);
          if (newCount) {
            var oldCountEl = document.querySelector('.collection-toolbar__count');
            if (oldCountEl) oldCountEl.textContent = newCount.textContent;
          }
        }
        if (newPanel && filtersPanel) {
          var openState = filtersPanel.classList.contains('is-open');
          newPanel.hidden = !openState;
          if (openState) newPanel.classList.add('is-open');
          filtersPanel.replaceWith(newPanel);
        }
        window.history.pushState({}, '', url);
        filtersRenderedUrl = window.location.href;
        // Filtering updates the grid in place, so unlike a default full-page navigation the
        // browser keeps the old scroll position — leaving the user stranded mid-page in the
        // NEW results. Restore the default behaviour: start at the top. If the mobile filter
        // drawer is open, its body.drawer-open lock makes scrollTo a silent no-op — defer the
        // jump to the drawer's close handler instead.
        if (!typing) {
          if (document.body.classList.contains('drawer-open')) {
            filtersPendingScroll = true;
          } else {
            scrollResultsToTop();
          }
        }
        initCollectionFilters();
        initInfiniteScroll();
        initProductCardCarousel();
        refreshWishlistButtons();
        applyClientSideDateSort();
        // The panel swap destroyed focus mid-typing — put the user back in the same price
        // field (with whatever they had typed) so they can keep going uninterrupted.
        if (typing && typing.name) {
          var again = document.querySelector('[data-filters-form] [name="' + typing.name + '"]');
          if (again) { again.value = typing.value; again.focus(); }
        }
      } catch (e) { console.error(e); }
    }

    // Run once on init for direct URL loads (function is module-level now)
    applyClientSideDateSort();

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        applyUrl(url.toString());
      });
    }

    if (filtersForm) {
      function applyFilters() {
        var data = new FormData(filtersForm);
        var url = new URL(window.location.pathname, window.location.origin);
        var hasVariantFilter = false;
        data.forEach(function (value, key) {
          if (value) {
            url.searchParams.append(key, value);
            if (key.indexOf('filter.v.option.') === 0) hasVariantFilter = true;
          }
        });
        // A size/color filter should mean "this size is IN STOCK", not merely "this variant
        // exists" (Shopify's default). Adding the availability filter makes Shopify require a
        // SINGLE variant to satisfy both conditions, so "M + available" only returns products
        // whose M is actually purchasable. The availability filter is hidden from the sidebar
        // (main-collection.liquid skips it), so it never renders as a checkbox and drops out
        // automatically when the last size/color filter is unchecked.
        if (hasVariantFilter) url.searchParams.set('filter.v.availability', '1');
        if (sortSelect) url.searchParams.set('sort_by', sortSelect.value);
        applyUrl(url.toString());
      }

      filtersForm.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
      });

      // Auto-apply on input change: instant for checkboxes/selects, debounced for text/number
      var debounceTimer;
      filtersForm.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.matches('input, select')) return;
        if (t.type === 'number' || t.type === 'text') {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(applyFilters, 400);
        } else {
          applyFilters();
        }
      });
      filtersForm.addEventListener('input', function (e) {
        var t = e.target;
        if (!t.matches('input[type="number"], input[type="text"]')) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFilters, 500);
      });
    }
  }

  // ============ Cart upsells ============
  async function initCartUpsells() {
    var container = document.querySelector('[data-cart-upsells]');
    if (!container) return;
    var productId = container.getAttribute('data-product-id');
    var list = container.querySelector('[data-cart-upsells-list]');
    if (!productId || !list) return;

    try {
      var res = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related');
      if (!res.ok) return;
      var data = await res.json();
      var products = (data.products || []).slice(0, 4);
      if (products.length === 0) {
        container.style.display = 'none';
        return;
      }
      list.innerHTML = products.map(function (p) {
        var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="">' : '';
        var price = p.price ? (p.price / 100).toFixed(3) : '';
        return (
          '<a class="cart-upsell-card" href="' + p.url + '">' +
            '<div class="cart-upsell-card__media">' + img + '</div>' +
            '<div class="cart-upsell-card__info">' +
              '<div class="cart-upsell-card__title">' + p.title + '</div>' +
              '<div class="cart-upsell-card__price">' + price + '</div>' +
            '</div>' +
          '</a>'
        );
      }).join('');
    } catch (e) {
      container.style.display = 'none';
    }
  }

  // Scroll-triggered animations
  function initScrollAnimations() {
    var cfg = (window.theme && window.theme.settings && window.theme.settings.animation) || {};
    if (!cfg.enabled || !cfg.onScroll) return;
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('[data-animate]');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  // Lazy load: ensure native loading="lazy" everywhere when enabled
  function initLazyLoad() {
    if (!window.theme || !window.theme.settings || !window.theme.settings.lazyLoad) return;
    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
    });
  }

  // ----- Enterprise widget JS ---------------------------------------------

  // Parallax image
  function initParallax() {
    var els = document.querySelectorAll('[data-parallax-target]');
    if (!els.length) return;
    function update() {
      els.forEach(function (el) {
        var rect = el.parentElement.getBoundingClientRect();
        var winH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > winH) return;
        var speed = parseFloat(el.parentElement.dataset.parallaxSpeed || 30) / 100;
        var offset = (rect.top + rect.height / 2 - winH / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Scrolling banner — sync speed CSS var from data attr
  function initScrollingBanner() {
    document.querySelectorAll('.scrolling-banner__track').forEach(function (track) {
      var s = parseFloat(track.dataset.scrollSpeed || 25);
      track.style.setProperty('--scroll-speed', s + 's');
    });
  }

  // Vertical ticker
  function initVerticalTicker() {
    document.querySelectorAll('[data-vertical-ticker]').forEach(function (el) {
      var interval = parseInt(el.dataset.interval || 3000, 10);
      var ul = el.querySelector('ul');
      if (!ul) return;
      var rowH = ul.firstElementChild ? ul.firstElementChild.offsetHeight : 40;
      var idx = 0;
      var count = ul.children.length;
      if (count < 2) return;
      // Duplicate first item at end for smooth loop
      var clone = ul.firstElementChild.cloneNode(true);
      ul.appendChild(clone);
      setInterval(function () {
        idx++;
        ul.style.transform = 'translateY(-' + (idx * rowH) + 'px)';
        if (idx >= count) {
          setTimeout(function () {
            ul.style.transition = 'none';
            idx = 0;
            ul.style.transform = 'translateY(0)';
            // Force reflow
            void ul.offsetHeight;
            ul.style.transition = '';
          }, 400);
        }
      }, interval);
    });
  }

  // Welcome video
  function initWelcomeVideo() {
    var el = document.querySelector('[data-welcome-video]');
    if (!el) return;
    var showOnce = el.dataset.showOnce === 'true';
    var key = 'capon_welcome_video_shown';
    if (showOnce && localStorage.getItem(key)) return;
    var delay = parseInt(el.dataset.delay || 2000, 10);
    setTimeout(function () {
      el.hidden = false;
      if (showOnce) localStorage.setItem(key, '1');
    }, delay);
    el.querySelectorAll('[data-welcome-close]').forEach(function (b) {
      b.addEventListener('click', function () { el.hidden = true; });
    });
  }

  // Quick view modal
  function initQuickViewModal() {
    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-quick-view-body]');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.dataset.productHandle;
      if (!handle) return;
      modal.hidden = false;
      body.innerHTML = '<p class="quick-view__loading">Loading…</p>';
      fetch('/products/' + handle + '?section_id=quick-view-product', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var content = tmp.querySelector('[data-quick-view-content]');
          body.innerHTML = '';
          if (content) body.appendChild(content);
          wireQuickViewVariants(body);
        })
        .catch(function () { body.innerHTML = '<p>Could not load product.</p>'; });
    });

    modal.querySelectorAll('[data-quick-view-close]').forEach(function (b) {
      b.addEventListener('click', function () { modal.hidden = true; body.innerHTML = ''; });
    });
  }

  function wireQuickViewVariants(scope) {
    var dataScript = scope.querySelector('[data-qv-product]');
    if (!dataScript) return;
    var product;
    try { product = JSON.parse(dataScript.textContent); } catch (e) { return; }
    var variantInput = scope.querySelector('[data-qv-variant-id]');
    var optionSelects = scope.querySelectorAll('[data-qv-option-1],[data-qv-option-2],[data-qv-option-3]');
    function update() {
      var selected = [];
      optionSelects.forEach(function (s) { selected.push(s.value); });
      var match = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (match) variantInput.value = match.id;
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', update); });
  }

  // Quick compare
  function initQuickCompareWidget() {
    var widget = document.querySelector('[data-quick-compare]');
    if (!widget) return;
    var max = parseInt(widget.dataset.maxItems || 3, 10);
    var key = 'capon_quick_compare';
    var drawer = widget.querySelector('[data-quick-compare-drawer]');
    var body = widget.querySelector('[data-quick-compare-body]');
    var count = widget.querySelector('[data-quick-compare-count]');

    function load() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    function save(arr) { localStorage.setItem(key, JSON.stringify(arr)); }
    function render() {
      var items = load();
      count.textContent = items.length;
      widget.querySelector('[data-quick-compare-open]').dataset.count = items.length;
      if (items.length === 0) {
        body.innerHTML = '<p class="quick-compare__empty">No products added yet.</p>';
        return;
      }
      Promise.all(items.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.json(); });
      })).then(function (products) {
        body.innerHTML = '<div style="display:grid;grid-template-columns:repeat(' + products.length + ',1fr);gap:12px;">' +
          products.map(function (p) {
            var qvSrc = normalizeShopifyImgUrl(jsonProductImageSrc(p));
            return '<div><img src="' + escapeHtml(qvSrc) + '" style="width:100%"><strong>' + p.title +
              '</strong><div>$' + (p.price / 100).toFixed(2) + '</div>' +
              '<button data-remove="' + p.handle + '">Remove</button></div>';
          }).join('') + '</div>';
        body.querySelectorAll('[data-remove]').forEach(function (b) {
          b.addEventListener('click', function () {
            save(load().filter(function (x) { return x !== b.dataset.remove; }));
            render();
          });
        });
      });
    }

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-quick-compare-add]');
      if (add) {
        var arr = load();
        var h = add.dataset.productHandle;
        if (h && arr.indexOf(h) === -1 && arr.length < max) {
          arr.push(h); save(arr); render();
        }
      }
    });
    widget.querySelector('[data-quick-compare-open]').addEventListener('click', function () { drawer.hidden = false; });
    widget.querySelectorAll('[data-quick-compare-close]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.hidden = true; });
    });
    render();
  }

  // Product zoom
  function initProductZoom() {
    document.querySelectorAll('[data-product-zoom]').forEach(function (root) {
      var modal = root.querySelector('[data-product-zoom-modal]');
      var trigger = root.querySelector('[data-product-zoom-open]');
      if (!trigger || !modal) return;
      trigger.addEventListener('click', function () { modal.hidden = false; });
      root.querySelectorAll('[data-product-zoom-close]').forEach(function (b) {
        b.addEventListener('click', function () { modal.hidden = true; });
      });
    });
  }

  // Product share — copy link
  function initProductShare() {
    document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || location.href;
        navigator.clipboard.writeText(url).then(function () {
          var orig = btn.innerHTML;
          btn.textContent = '✓';
          setTimeout(function () { btn.innerHTML = orig; }, 1500);
        });
      });
    });
  }

  // Product card carousel
  function initProductCardCarousel() {
    document.querySelectorAll('[data-card-carousel]').forEach(function (root) {
      // Re-run after filtering / infinite scroll to bind NEW cards — guard so cards that
      // survived a re-run don't accumulate duplicate dot listeners.
      if (root.dataset.carouselBound) return;
      var slides = root.querySelector('[data-card-slides]');
      var dots = root.querySelectorAll('[data-card-dot]');
      if (!slides || !dots.length) return;
      root.dataset.carouselBound = '1';
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          var i = parseInt(dot.dataset.cardDot, 10);
          slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          dot.classList.add('is-active');
        });
      });
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      });
    });
  }

  // Variant sync on media change (PDP)
  function initVariantSyncOnMedia() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      var selects = form.querySelectorAll('select[name^="options"]');
      if (!selects.length) return;
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var alt = s.value;
          var gallery = document.querySelector('[data-product-gallery]') || document.querySelector('.product__media');
          if (!gallery) return;
          var match = gallery.querySelector('[data-variant-option="' + CSS.escape(alt) + '"]');
          if (match && match.scrollIntoView) match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    });
  }

  // Shipping calculator
  function initShippingCalculator() {
    var form = document.querySelector('[data-shipping-calculator]');
    if (!form) return;
    var result = form.querySelector('[data-shipping-result]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      result.textContent = 'Calculating…';
      var fd = new FormData(form);
      var params = new URLSearchParams();
      params.set('shipping_address[country]', fd.get('country') || '');
      params.set('shipping_address[province]', fd.get('province') || '');
      params.set('shipping_address[zip]', fd.get('zip') || '');
      fetch('/cart/shipping_rates.json?' + params.toString())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var rates = (data.shipping_rates || []);
          if (!rates.length) { result.textContent = 'No rates available for this address.'; return; }
          result.innerHTML = rates.map(function (r) {
            return '<div class="shipping-calculator__rate"><strong>' + r.name + '</strong> — ' + r.price + ' ' + (r.currency || '') + '</div>';
          }).join('');
        })
        .catch(function () { result.textContent = 'Unable to fetch rates right now.'; });
    });
  }

  // Global music player
  function initGlobalMusic() {
    var el = document.querySelector('[data-global-music]');
    if (!el) return;
    var audio = el.querySelector('[data-music-audio]');
    var btn = el.querySelector('[data-music-toggle]');
    var iconPlay = el.querySelector('.global-music__icon-play');
    var iconPause = el.querySelector('.global-music__icon-pause');
    if (!audio || !btn) return;
    btn.addEventListener('click', function () {
      if (audio.paused) {
        audio.muted = false;
        audio.play();
        iconPlay.hidden = true; iconPause.hidden = false;
      } else {
        audio.pause();
        iconPlay.hidden = false; iconPause.hidden = true;
      }
    });
  }

  // External URLs handler
  function initExternalLinks() {
    document.querySelectorAll('a[href^="http"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        if (u.host && u.host !== location.host) {
          if (!a.target) a.target = '_blank';
          var rel = (a.rel || '').split(/\s+/);
          if (rel.indexOf('noopener') === -1) rel.push('noopener');
          a.rel = rel.filter(Boolean).join(' ');
        }
      } catch (e) {}
    });
  }

  // Conditional gift — auto add/remove via cart API
  function initConditionalGift() {
    var el = document.querySelector('[data-conditional-gift]');
    if (!el) return;
    var variantId = el.dataset.variantId;
    var qualifies = el.dataset.qualifies === 'true';
    if (!variantId) return;
    if (qualifies) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var has = cart.items.some(function (i) { return String(i.variant_id) === String(variantId); });
        if (!has) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, properties: { _free_gift: 'true' } })
          });
        }
      });
    }
  }

  // ===== Free/Growth/Professional widget JS ============================

  // Scroll indicator (top progress bar)
  function initScrollIndicator() {
    var el = document.querySelector('[data-scroll-indicator-fill]');
    if (!el) return;
    function update() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docH > 0 ? (window.scrollY / docH) * 100 : 0;
      el.style.width = Math.min(100, Math.max(0, pct)) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Tabs (product-tabs + content-tabs)
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab-trigger]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-tab-trigger');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-tab-panel') === idx;
            p.classList.toggle('is-active', match);
            p.hidden = !match;
          });
        });
      });
    });
  }

  // Sticky ATC
  function initStickyATC() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var atcForm = document.querySelector('main form[action="/cart/add"]:not(.product-card__quick-add)');
    function update() {
      if (!atcForm) { bar.hidden = true; return; }
      var rect = atcForm.getBoundingClientRect();
      var off = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.hidden = false;
      bar.classList.toggle('is-visible', off);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Before/After slider
  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(function (root) {
      var input = root.querySelector('[data-before-after-input]');
      var clip = root.querySelector('[data-before-clip]');
      var handle = root.querySelector('[data-before-after-handle]');
      function setPos(val) {
        var pct = val + '%';
        if (clip) clip.style.clipPath = 'inset(0 calc(100% - ' + pct + ') 0 0)';
        if (handle) handle.style.left = pct;
      }
      if (input) {
        input.addEventListener('input', function () { setPos(input.value); });
        setPos(input.value);
      }
    });
  }

  // Color swatches sync with hidden option select
  function initColorSwatches() {
    document.querySelectorAll('[data-color-swatches]').forEach(function (fs) {
      var pos = fs.getAttribute('data-option-position');
      var label = fs.querySelector('[data-color-swatch-selected]');
      fs.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"]')) return;
        if (label) label.textContent = e.target.value;
        // Mirror into the main option select on PDP if present
        var form = e.target.closest('form');
        if (!form) form = document.querySelector('main form[action="/cart/add"]');
        if (form) {
          var sel = form.querySelector('[name="options[' + e.target.name.replace(/^options\[|\]$/g, '') + ']"]');
          if (sel && sel !== e.target) sel.value = e.target.value;
        }
      });
    });
  }

  // Size chart modal
  function initSizeChart() {
    var openers = document.querySelectorAll('[data-size-chart-open]');
    if (!openers.length) return;

    function getModal(btn) {
      var id = btn.getAttribute('aria-controls');
      if (id) {
        var byId = document.getElementById(id);
        if (byId) return byId;
      }
      // Fallback: nearest parent-scoped modal
      var root = btn.closest('[data-size-chart]') || document;
      return root.querySelector('[data-size-chart-modal]');
    }

    function wrapTables(modal) {
      if (modal.dataset.tablesWrapped === '1') return;
      var body = modal.querySelector('.size-chart-modal__body');
      if (!body) return;
      body.querySelectorAll('table').forEach(function (table) {
        if (table.parentElement && table.parentElement.classList.contains('size-chart-table-wrap')) return;
        var wrap = document.createElement('div');
        wrap.className = 'size-chart-table-wrap';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });
      modal.dataset.tablesWrapped = '1';
    }

    function openModal(modal) {
      if (!modal) return;
      wrapTables(modal);
      modal.hidden = false;
      // force reflow so the CSS transition runs
      void modal.offsetHeight;
      modal.classList.add('is-open');
      document.body.classList.add('size-chart-open');
      var closeBtn = modal.querySelector('[data-size-chart-close]:not(.size-chart-modal__overlay)');
      if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('size-chart-open');
      setTimeout(function () { modal.hidden = true; }, 220);
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(getModal(btn));
      });
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var closer = t.closest('[data-size-chart-close]');
      if (!closer) return;
      var modal = closer.closest('[data-size-chart-modal]');
      closeModal(modal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-size-chart-modal].is-open');
      if (open) closeModal(open);
    });
  }

  // Inventory quantity — update on variant change
  function initInventoryQuantity() {
    var node = document.querySelector('[data-inventory-quantity]');
    if (!node) return;
    document.addEventListener('change', function (e) {
      if (!e.target.matches('select[name^="options"], input[name^="options"]')) return;
      // Trust Shopify's full PDP reload, or wire to a product JSON refresh in your PDP js
    });
  }

  // Delivery date estimator
  function initDeliveryDate() {
    document.querySelectorAll('[data-delivery-date]').forEach(function (el) {
      var minDays = parseInt(el.dataset.minDays || 3, 10);
      var maxDays = parseInt(el.dataset.maxDays || 7, 10);
      var cutoff = parseInt(el.dataset.cutoffHour || 14, 10);
      var now = new Date();
      var afterCutoff = now.getHours() >= cutoff;
      var base = new Date(now);
      if (afterCutoff) base.setDate(base.getDate() + 1);
      var min = new Date(base); min.setDate(base.getDate() + minDays);
      var max = new Date(base); max.setDate(base.getDate() + maxDays);
      var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
      var target = el.querySelector('[data-delivery-date-range]');
      if (target) target.textContent = fmt(min) + ' – ' + fmt(max);
    });
  }

  // Delivery time (countdown to today's cutoff)
  function initDeliveryTime() {
    document.querySelectorAll('[data-delivery-time]').forEach(function (el) {
      var h = parseInt(el.dataset.cutoffHour || 14, 10);
      var m = parseInt(el.dataset.cutoffMinute || 0, 10);
      var target = el.querySelector('[data-delivery-time-countdown]');
      function tick() {
        var now = new Date();
        var cutoff = new Date(now); cutoff.setHours(h, m, 0, 0);
        if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
        var diff = cutoff - now;
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        if (target) target.textContent = hh + 'h ' + mm + 'm';
      }
      tick();
      setInterval(tick, 60000);
    });
  }

  // Quantity breaks — sync hidden qty input on PDP
  function initQuantityBreaks() {
    var root = document.querySelector('[data-quantity-breaks]');
    if (!root) return;
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty]')) return;
      var qty = parseInt(e.target.dataset.qty || 1, 10);
      var qtyInput = document.querySelector('main form[action="/cart/add"] input[name="quantity"]');
      if (qtyInput) qtyInput.value = qty;
    });
  }

  // Back in stock — POST to Shopify customer endpoint (best-effort)
  function initBackInStock() {
    document.querySelectorAll('[data-back-in-stock]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[name="email"]').value;
        var pid = form.dataset.productId;
        var vid = form.dataset.variantId;
        var result = form.querySelector('[data-back-in-stock-result]');
        var fd = new FormData();
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'back-in-stock');
        fd.append('contact[body]', 'Back in stock: product ' + pid + ' variant ' + vid);
        fd.append('form_type', 'contact');
        fd.append('utf8', '✓');
        fetch('/contact', { method: 'POST', body: fd })
          .then(function () { if (result) result.textContent = "Thanks — we'll email you when it's back."; form.reset(); })
          .catch(function () { if (result) result.textContent = 'Something went wrong. Try again later.'; });
      });
    });
  }

  // Cart discount
  function initCartDiscount() {
    document.querySelectorAll('[data-cart-discount]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (form.querySelector('[data-cart-discount-input]').value || '').trim();
        if (!code) return;
        var result = form.querySelector('[data-cart-discount-result]');
        fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
          .then(function () { if (result) result.textContent = 'Code applied. Continue to checkout to confirm.'; })
          .catch(function () { if (result) result.textContent = 'Could not apply this code.'; });
      });
    });
  }

  // Cart countdown
  function initCartCountdown() {
    var el = document.querySelector('[data-cart-countdown]');
    if (!el) return;
    var minutes = parseInt(el.dataset.minutes || 10, 10);
    var key = 'capon_cart_countdown_until';
    var resetOnActivity = el.dataset.resetOnActivity === 'true';
    var display = el.querySelector('[data-cart-countdown-display]');
    function start() { localStorage.setItem(key, String(Date.now() + minutes * 60000)); }
    if (!localStorage.getItem(key)) start();
    if (resetOnActivity) {
      document.addEventListener('cart:updated', start);
      ['click', 'keydown', 'scroll'].forEach(function (ev) {
        document.addEventListener(ev, function () { start(); }, { passive: true, once: true });
      });
    }
    function tick() {
      var until = parseInt(localStorage.getItem(key) || 0, 10);
      var diff = until - Date.now();
      if (diff <= 0) { display.textContent = '00:00'; start(); return; }
      var mm = Math.floor(diff / 60000);
      var ss = Math.floor((diff % 60000) / 1000);
      display.textContent = String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }

  // Cart notification (toast on add-to-cart)
  function initCartNotification() {
    var note = document.querySelector('[data-cart-notification]');
    if (!note) return;
    var msg = note.querySelector('[data-cart-notification-message]');
    var timer;
    var repositionHandler;

    function unbindReposition() {
      if (!repositionHandler) return;
      window.removeEventListener('scroll', repositionHandler);
      window.removeEventListener('resize', repositionHandler);
      repositionHandler = null;
    }

    function clearAnchorLayout() {
      unbindReposition();
      note.classList.remove('cart-notification--anchored');
      [
        '--cart-notify-x',
        '--cart-notify-y',
        'position',
        'left',
        'top',
        'right',
        'bottom',
        'width',
        'max-width',
        'transform',
        'margin'
      ].forEach(function (p) {
        note.style.removeProperty(p);
      });
    }

    function setAnchorPosition(anchor) {
      if (!anchor || !anchor.isConnected) return;
      var r = anchor.getBoundingClientRect();
      var pad = 12;
      var w = Math.min(360, Math.max(200, window.innerWidth - 2 * pad));
      var cx = r.left + r.width / 2;
      cx = Math.max(pad + w / 2, Math.min(window.innerWidth - pad - w / 2, cx));
      var imp = 'important';
      note.style.setProperty('position', 'fixed', imp);
      note.style.setProperty('left', cx + 'px', imp);
      note.style.setProperty('top', r.top + 'px', imp);
      note.style.setProperty('right', 'auto', imp);
      note.style.setProperty('bottom', 'auto', imp);
      note.style.setProperty('width', w + 'px', imp);
      note.style.setProperty('max-width', w + 'px', imp);
      note.style.setProperty('margin', '0', imp);
      note.style.setProperty('transform', 'translate(-50%, calc(-100% - 10px))', imp);
    }

    function bindReposition(anchor) {
      unbindReposition();
      repositionHandler = function () { setAnchorPosition(anchor); };
      window.addEventListener('scroll', repositionHandler, { passive: true });
      window.addEventListener('resize', repositionHandler);
    }

    function dismiss() {
      unbindReposition();
      note.classList.remove('is-visible');
      setTimeout(function () {
        note.hidden = true;
        clearAnchorLayout();
      }, 250);
    }

    /** Product page: move toast into .pdp-buy so CSS can place it above the row (no fragile fixed math). */
    function ensurePdpBuyMount() {
      var buy = document.querySelector('.pdp-buy');
      if (!buy) {
        note.classList.remove('cart-notification--pdp-mounted');
        if (note.parentElement && !document.body.contains(note)) {
          document.body.appendChild(note);
        }
        return;
      }
      if (!buy.contains(note)) {
        clearAnchorLayout();
        note.classList.remove('cart-notification--pdp-mounted');
        buy.insertBefore(note, buy.firstChild);
      }
      note.classList.add('cart-notification--pdp-mounted');
    }

    function resolveAtcAnchor(detail) {
      var a = detail && detail.atcAnchor;
      if (a && a.nodeType === 1 && a.isConnected) return a;
      a = document.querySelector('#ProductForm [data-pdp-atc], #ProductForm button[name="add"], #ProductForm input[name="add"]');
      if (a && a.isConnected) return a;
      a = document.querySelector('.pdp-form [data-pdp-atc], .pdp-form button[name="add"], .pdp-buy button[name="add"], .pdp-buy__atc');
      if (a && a.isConnected) return a;
      a = document.querySelector('[data-pdp-atc]');
      if (a && a.isConnected) return a;
      a = document.querySelector('[data-pdp-form] button[name="add"], [data-pdp-form] input[name="add"]');
      if (a && a.isConnected) return a;
      a = document.querySelector('[data-pdp-sticky-atc]');
      if (a && a.isConnected) return a;
      a = document.querySelector('main button[name="add"], main input[name="add"]');
      if (a && a.isConnected) return a;
      a = document.querySelector('.featured-product__atc, .sticky-atc__form button[name="add"]');
      return a && a.isConnected ? a : null;
    }

    function showToast() {
      note.hidden = false;
      note.classList.remove('is-visible');
      requestAnimationFrame(function () {
        note.classList.add('is-visible');
      });
      clearTimeout(timer);
      timer = setTimeout(dismiss, 3000);
    }

    function anchorIsStickyAtc(el) {
      return el && el.nodeType === 1 && typeof el.matches === 'function' && el.matches('[data-pdp-sticky-atc]');
    }

    document.addEventListener('cart:item-added', function (e) {
      if (msg && e.detail && e.detail.title) msg.textContent = e.detail.title;

      var detailAnchor = e.detail && e.detail.atcAnchor;
      var toastAnchor = null;
      if (anchorIsStickyAtc(detailAnchor)) {
        toastAnchor = detailAnchor;
      } else {
        var stickyBar = document.querySelector('[data-pdp-sticky].is-visible');
        var stickyBtn = stickyBar && stickyBar.querySelector('[data-pdp-sticky-atc]');
        if (stickyBar && stickyBtn) toastAnchor = stickyBtn;
      }

      // PDP-mounted toast is absolute inside .pdp-buy — off-screen when user scrolled to sticky bar.
      // Prefer event detail (set when add ran via sticky); else visible sticky bar.
      if (toastAnchor && toastAnchor.isConnected) {
        note.classList.remove('cart-notification--pdp-mounted');
        if (note.parentElement !== document.body) {
          document.body.appendChild(note);
        }
        clearAnchorLayout();
        note.classList.add('cart-notification--anchored');
        setAnchorPosition(toastAnchor);
        bindReposition(toastAnchor);
        showToast();
        return;
      }

      ensurePdpBuyMount();

      if (note.classList.contains('cart-notification--pdp-mounted')) {
        clearAnchorLayout();
        showToast();
        return;
      }

      var anchor = resolveAtcAnchor(e.detail);
      if (anchor && anchor.nodeType === 1 && anchor.isConnected) {
        clearAnchorLayout();
        note.classList.add('cart-notification--anchored');
        setAnchorPosition(anchor);
        bindReposition(anchor);
      } else {
        clearAnchorLayout();
      }
      showToast();
    });

    document.addEventListener('shopify:section:load', function () {
      ensurePdpBuyMount();
    });

    ensurePdpBuyMount();

    note.querySelectorAll('[data-cart-notification-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearTimeout(timer);
        dismiss();
      });
    });
  }

  // Cart reminder
  function initCartReminder() {
    var el = document.querySelector('[data-cart-reminder]');
    if (!el) return;
    var seconds = parseInt(el.dataset.inactivitySeconds || 60, 10);
    var idle;
    function show() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (c.item_count > 0) el.hidden = false;
      });
    }
    function resetIdle() {
      clearTimeout(idle);
      el.hidden = true;
      idle = setTimeout(show, seconds * 1000);
    }
    ['mousemove', 'keydown', 'scroll', 'touchstart', 'click'].forEach(function (ev) {
      document.addEventListener(ev, resetIdle, { passive: true });
    });
    el.querySelectorAll('[data-cart-reminder-close]').forEach(function (b) {
      b.addEventListener('click', function () { el.hidden = true; });
    });
    resetIdle();
  }

  // Age check
  function initAgeCheck() {
    var el = document.querySelector('[data-age-check]');
    if (!el) return;
    var key = 'capon_age_check_passed';
    if (localStorage.getItem(key) === '1') return;
    el.hidden = false;
    el.querySelector('[data-age-check-confirm]').addEventListener('click', function () {
      localStorage.setItem(key, '1'); el.hidden = true;
    });
    el.querySelector('[data-age-check-deny]').addEventListener('click', function () {
      var u = el.querySelector('[data-age-check-deny-url]');
      window.location.href = (u && u.value) || 'https://www.google.com';
    });
  }

  // Sale popup notification — cycle through items
  function initSalePopup() {
    var root = document.querySelector('[data-sale-popup]');
    if (!root) return;
    var items = root.querySelectorAll('[data-sale-popup-item]');
    if (!items.length) return;
    var interval = parseInt(root.dataset.interval || 8000, 10);
    var idx = 0;
    function showNext() {
      items.forEach(function (i) { i.hidden = true; });
      items[idx].hidden = false;
      idx = (idx + 1) % items.length;
    }
    setTimeout(showNext, 3000);
    setInterval(showNext, interval);
    root.querySelectorAll('[data-sale-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { b.closest('[data-sale-popup-item]').hidden = true; });
    });
  }

  // Upsell popup
  function initUpsellPopup() {
    var el = document.querySelector('[data-upsell-popup]');
    if (!el) return;
    var trigger = el.dataset.trigger;
    var delay = parseInt(el.dataset.delay || 0, 10);
    var showOnce = el.dataset.showOnce === 'true';
    var key = 'capon_upsell_popup_shown';
    if (showOnce && sessionStorage.getItem(key) === '1') return;
    function show() {
      el.hidden = false;
      if (showOnce) sessionStorage.setItem(key, '1');
    }
    if (trigger === 'delay') {
      setTimeout(show, delay);
    } else if (trigger === 'exit') {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget && !el.hidden === false) show();
      });
    } else if (trigger === 'add_to_cart') {
      document.addEventListener('cart:item-added', show);
    }
    el.querySelectorAll('[data-upsell-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { el.hidden = true; });
    });
  }

  // Country blocker
  function initCountryBlocker() {
    var el = document.querySelector('[data-country-blocker]');
    if (!el) return;
    var mode = el.dataset.mode;
    var list = (el.dataset.countries || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
    if (!list.length) return;
    fetch('https://api.country.is/').then(function (r) { return r.json(); }).then(function (data) {
      var cc = (data.country || '').toUpperCase();
      var blocked = false;
      if (mode === 'block' && list.indexOf(cc) !== -1) blocked = true;
      if (mode === 'allow' && list.indexOf(cc) === -1) blocked = true;
      if (blocked) el.hidden = false;
    }).catch(function () {});
  }

  // Inactive tab message
  function initInactiveTabMessage() {
    var el = document.querySelector('[data-inactive-tab]');
    if (!el) return;
    var msg = el.dataset.message;
    var original = el.dataset.original || document.title;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.title = msg;
      else document.title = original;
    });
  }

  // Fly to cart
  function initFlyToCart() {
    document.addEventListener('cart:item-added', function (e) {
      var img = e.detail && e.detail.sourceImg;
      var cartIcon = document.querySelector('[data-cart-toggle]') || document.querySelector('[data-cart-count]');
      if (!img || !cartIcon) return;
      var rect = img.getBoundingClientRect();
      var dest = cartIcon.getBoundingClientRect();
      var clone = img.cloneNode();
      clone.className = 'fly-to-cart-clone';
      clone.style.left = rect.left + 'px';
      clone.style.top = rect.top + 'px';
      clone.style.width = Math.min(80, rect.width) + 'px';
      clone.style.height = Math.min(80, rect.height) + 'px';
      document.body.appendChild(clone);
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + (dest.left - rect.left) + 'px,' + (dest.top - rect.top) + 'px) scale(0.2)';
        clone.style.opacity = '0';
      });
      setTimeout(function () { clone.remove(); }, 1200);
    });
  }

  // Add-to-cart animation
  function initAddToCartAnimation() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !(form instanceof HTMLFormElement) || !formPostsToCartAdd(form)) return;
      var btn = form.querySelector('[data-pdp-atc], button[name="add"], input[name="add"]')
        || form.querySelector('button[type="submit"], button[name="add"]');
      if (!btn) return;
      btn.classList.add('is-adding');
      setTimeout(function () { btn.classList.remove('is-adding'); }, 700);
      // Fire cart:item-added with image reference (atcAnchor helps toast placement; AJAX handler sends the definitive event)
      var img = form.closest('[data-product-card]') ? form.closest('[data-product-card]').querySelector('img') : null;
      var title = form.closest('[data-product-card]') ? (form.closest('[data-product-card]').querySelector('.product-card__title') || {}).textContent : '';
      var anchor = (e.submitter && e.submitter.name === 'add') ? e.submitter : btn;
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { title: title, sourceImg: img, atcAnchor: anchor } }));
    }, true);
  }

  // Cart favicon
  function updateCartFavicon(count) {
    if (!settings('cartFavicon')) return;
    var c = document.createElement('canvas'); c.width = 32; c.height = 32;
    var ctx = c.getContext('2d');
    // Background — try to draw existing favicon, else solid
    var icon = new Image();
    icon.crossOrigin = 'anonymous';
    var faviconLink = document.querySelector('link[rel="icon"]');
    icon.onload = function () {
      try { ctx.drawImage(icon, 0, 0, 32, 32); } catch (e) {}
      drawBadge();
    };
    icon.onerror = drawBadge;
    if (faviconLink) icon.src = faviconLink.href;
    else drawBadge();

    function drawBadge() {
      if (count > 0) {
        ctx.fillStyle = '#d83232';
        ctx.beginPath(); ctx.arc(24, 8, 8, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#fff';
        ctx.font = 'bold 11px sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(count > 9 ? '9+' : String(count), 24, 8);
      }
      var url = c.toDataURL('image/png');
      if (faviconLink) faviconLink.href = url;
      else {
        var l = document.createElement('link'); l.rel = 'icon'; l.href = url;
        document.head.appendChild(l);
      }
    }
  }
  function settings(key) { return window.theme && window.theme.flags && window.theme.flags[key]; }
  function initCartFavicon() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartFavicon(c.item_count); });
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartFavicon(c.item_count); });
    });
  }

  // Predictive search
  function initPredictiveSearch() {
    var widget = document.querySelector('[data-predictive-search]');
    if (!widget) return;
    var input = widget.querySelector('[data-predictive-search-input]');
    var results = widget.querySelector('[data-predictive-search-results]');
    var min = parseInt(input.dataset.minChars || 2, 10);
    var resources = input.dataset.resources || 'product';
    var limit = parseInt(input.dataset.limit || 6, 10);
    var t;
    document.querySelectorAll('[data-predictive-search-open]').forEach(function (b) {
      b.addEventListener('click', function () { widget.hidden = false; setTimeout(function () { input.focus(); }, 50); });
    });
    widget.querySelectorAll('[data-predictive-search-close]').forEach(function (b) {
      b.addEventListener('click', function () { widget.hidden = true; });
    });
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < min) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=' + resources + '&resources[limit]=' + limit)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = ((data.resources || {}).results || {}).products || [];
            results.innerHTML = items.length
              ? items.map(function (p) {
                  var pImg = normalizeShopifyImgUrl(jsonProductImageSrc(p));
                  return '<a href="' + p.url + '" class="result">' +
                    (pImg ? '<img src="' + escapeHtml(pImg) + '">' : '') +
                    '<span><strong>' + p.title + '</strong><br><small>' + (p.price || '') + '</small></span></a>';
                }).join('')
              : '<p>No matches found.</p>';
          });
      }, 200);
    });
  }

  // Instagram stories player
  function initIgStories() {
    var section = document.querySelector('[data-ig-stories]');
    if (!section) return;
    var stories = Array.from(section.querySelectorAll('[data-story-content]')).map(function (s) {
      try { return JSON.parse(s.textContent); } catch (e) { return null; }
    }).filter(Boolean);
    var player = section.querySelector('[data-ig-stories-player]');
    var stage = player.querySelector('[data-ig-stories-stage]');
    var current = 0;
    function show(i) {
      if (i < 0 || i >= stories.length) { player.hidden = true; return; }
      current = i;
      var s = stories[i];
      stage.innerHTML = '<a href="' + (s.link || '#') + '"><img src="' + s.image + '" alt="' + (s.title || '') + '"></a>';
    }
    section.querySelectorAll('[data-ig-story]').forEach(function (btn, i) {
      btn.addEventListener('click', function () { player.hidden = false; show(i); });
    });
    player.querySelectorAll('[data-ig-stories-close]').forEach(function (b) {
      b.addEventListener('click', function () { player.hidden = true; });
    });
    player.querySelector('[data-ig-stories-prev]').addEventListener('click', function () { show(current - 1); });
    player.querySelector('[data-ig-stories-next]').addEventListener('click', function () { show(current + 1); });
  }

  // Social discount popup
  function initSocialDiscount() {
    var el = document.querySelector('[data-social-discount]');
    if (!el) return;
    var key = 'capon_social_discount_shown';
    var showOnce = el.dataset.showOnce === 'true';
    if (showOnce && localStorage.getItem(key)) return;
    var delay = parseInt(el.dataset.delay || 30000, 10);
    setTimeout(function () { el.hidden = false; if (showOnce) localStorage.setItem(key, '1'); }, delay);
    el.querySelectorAll('[data-social-discount-close]').forEach(function (b) {
      b.addEventListener('click', function () { el.hidden = true; });
    });
    el.querySelectorAll('[data-social-discount-unlock]').forEach(function (a) {
      a.addEventListener('click', function () {
        var code = el.querySelector('[data-social-discount-code]');
        if (code) code.hidden = false;
      });
    });
    var copyBtn = el.querySelector('[data-social-discount-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var val = el.querySelector('[data-social-discount-value]').textContent;
        navigator.clipboard.writeText(val.trim()).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1500);
        });
      });
    }
  }

  // Upsell bundles
  function initUpsellBundles() {
    var root = document.querySelector('[data-upsell-bundles]');
    if (!root) return;
    var total = root.querySelector('[data-upsell-bundles-total]');
    var addBtn = root.querySelector('[data-upsell-bundles-add]');
    function getSelected() {
      return Array.from(root.querySelectorAll('[data-bundle-toggle]:checked')).map(function (i) {
        return { id: i.dataset.variantId, price: parseInt(i.dataset.price || 0, 10) };
      });
    }
    function update() {
      var items = getSelected();
      var sum = items.reduce(function (a, b) { return a + b.price; }, 0);
      if (total) total.textContent = formatMoney(sum);
    }
    root.addEventListener('change', update);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = getSelected();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: 1 }; }) })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { title: 'Bundle added' } }));
        });
      });
    }
  }
  function formatMoney(cents) {
    var s = (window.theme && window.theme.settings && window.theme.settings.currency) || {};
    var symbol = s.symbol || '$';
    var decimals = parseInt(s.decimalPlaces || '2', 10);
    var d = s.decimalSeparator || '.';
    var t = s.thousandsSeparator || ',';
    var amount = (cents / 100).toFixed(decimals);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
    var num = parts.join(d);
    return s.symbolPosition === 'after' ? num + ' ' + symbol : symbol + num;
  }

  // Page color changer
  function initPageColorChanger() {
    var el = document.querySelector('[data-page-color-changer]');
    if (!el) return;
    el.hidden = false;
    var panel = el.querySelector('[data-color-changer-panel]');
    el.querySelector('[data-color-changer-toggle]').addEventListener('click', function () { panel.hidden = !panel.hidden; });
    var html = document.documentElement;
    el.querySelectorAll('[data-color-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = b.dataset.colorMode;
        html.classList.remove('dark-mode');
        if (m === 'dark') html.classList.add('dark-mode');
        if (m === 'system') {
          if (window.matchMedia('(prefers-color-scheme: dark)').matches) html.classList.add('dark-mode');
        }
        localStorage.setItem('capon_color_mode', m);
      });
    });
    el.querySelectorAll('[data-font-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(b.dataset.fontSize, 10);
        html.classList.remove('font-size-up', 'font-size-down');
        if (v === 1) html.classList.add('font-size-up');
        if (v === -1) html.classList.add('font-size-down');
      });
    });
    var contrast = el.querySelector('[data-color-changer-contrast]');
    if (contrast) {
      contrast.addEventListener('change', function () { html.classList.toggle('high-contrast', contrast.checked); });
    }
    // Restore
    var saved = localStorage.getItem('capon_color_mode');
    if (saved === 'dark') html.classList.add('dark-mode');
  }

  // Gift wrap toggle (add/remove gift product to cart)
  function initGiftWrap() {
    document.querySelectorAll('[data-gift-wrap]').forEach(function (root) {
      var vid = root.dataset.variantId;
      var toggle = root.querySelector('[data-gift-wrap-toggle]');
      toggle.addEventListener('change', function () {
        if (toggle.checked) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1, properties: { _gift_wrap: 'true' } })
          });
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var item = c.items.find(function (i) { return String(i.variant_id) === String(vid); });
            if (item) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            }
          });
        }
      });
    });
  }

  // ============ Meta click IDs → cart attributes ============
  // The Purchase event is built server-side from Shopify's orders/create webhook, which runs on
  // Shopify's servers and cannot see browser cookies — so _fbp/_fbc were absent from every
  // Purchase (Meta reported 0% Click ID coverage on it). Storing them as cart attributes carries
  // them into the order payload as note_attributes, where the webhook can read them back.
  // Keys are underscore-prefixed so Shopify hides them from the customer at checkout.
  function initMetaClickIds() {
    if (window.Shopify && window.Shopify.designMode) return;

    function readCookie(name) {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]*)');
      return m ? decodeURIComponent(m[2]) : '';
    }

    var fbp = readCookie('_fbp');
    var fbc = readCookie('_fbc');

    // The custom pixel normally writes _fbc, but it loads asynchronously — if the shopper landed
    // here straight from an ad and buys immediately, derive it now so the click isn't lost.
    if (!fbc) {
      var match = window.location.search.match(/[?&]fbclid=([^&#]+)/i);
      if (match) {
        fbc = 'fb.1.' + Date.now() + '.' + decodeURIComponent(match[1]);
        document.cookie = '_fbc=' + fbc + '; max-age=7776000; path=/; SameSite=Lax';
      }
    }

    if (!fbp && !fbc) return;

    // Write only when the values change — normally a single request per session.
    var signature = fbp + '|' + fbc;
    try {
      if (sessionStorage.getItem('_capon_cart_ids') === signature) return;
    } catch (e) {}

    var attributes = {};
    if (fbp) attributes._fbp = fbp;
    if (fbc) attributes._fbc = fbc;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) {
        if (!res.ok) return;
        try { sessionStorage.setItem('_capon_cart_ids', signature); } catch (e) {}
      })
      .catch(function () {});
  }

  function init() {
    recordRecentFromPage();
    initAnnouncementBar();
    initTransparentHeader();
    initHeroParallax();
    initMobileDrawer();
    initCartDrawer();
    initCartForm();
    initMetaClickIds();
    initInfiniteScroll();
    initSearchModal();
    initSlideshows();
    initCountdowns();
    initRecentlyViewedSection();
    initProductPage();
    initDynamicCheckoutButtonFix();
    initRelatedProducts();
    initStickyHeaderOnScrollUp();
    initDropdownClick();
    initLocaleForm();
    initAnnouncementCountdown();
    updateCompareCount();
    initBackToTop();
    initCookieBanner();
    initNewsletterPopup();
    initShippingEta();
    initWishlist();
    initQuickView();
    initCollectionFilters();
    initCartUpsells();
    initScrollAnimations();
    initLazyLoad();
    initParallax();
    initScrollingBanner();
    initVerticalTicker();
    initWelcomeVideo();
    initQuickViewModal();
    initQuickCompareWidget();
    initProductZoom();
    initProductShare();
    initProductCardCarousel();
    initVariantSyncOnMedia();
    initShippingCalculator();
    initGlobalMusic();
    initExternalLinks();
    initConditionalGift();
    // Free/Growth/Professional
    initScrollIndicator();
    initTabs();
    initStickyATC();
    initBeforeAfter();
    initColorSwatches();
    initSizeChart();
    initInventoryQuantity();
    initDeliveryDate();
    initDeliveryTime();
    initQuantityBreaks();
    initBackInStock();
    initCartDiscount();
    initCartCountdown();
    initCartNotification();
    initCartReminder();
    initAgeCheck();
    initSalePopup();
    initUpsellPopup();
    initCountryBlocker();
    initInactiveTabMessage();
    initFlyToCart();
    initAddToCartAnimation();
    initCartFavicon();
    initPredictiveSearch();
    initIgStories();
    initSocialDiscount();
    initUpsellBundles();
    initPageColorChanger();
    initGiftWrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Scroll-linked logo rotation. Only runs when Theme settings > Logo > Animation
   is "Turn as you scroll" — <body data-logo-anim> is the single source of truth so
   the CSS and JS can't disagree about the active mode. Skipped for reduced motion. */
(function () {
  var _nhMode = document.body.getAttribute('data-logo-anim');
  if (_nhMode !== 'scroll' && _nhMode !== 'scrollglitch') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement, ticking = false;
  function update() {
    // 0.28deg per px scrolled: a full turn takes ~1300px, so it reads as responsive
    // without becoming a blur on a long collection page.
    root.style.setProperty('--nh-logo-rot', (window.scrollY * 0.28) + 'deg');
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

/* Never Human size guide: CM / IN toggle */
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-sg-unit]');
    if (!btn) return;
    var sg = btn.closest('[data-nh-size-guide]');
    if (!sg) return;
    sg.setAttribute('data-unit', btn.getAttribute('data-sg-unit'));
    var all = sg.querySelectorAll('[data-sg-unit]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === btn;
      all[i].classList.toggle('is-active', on);
      all[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  });
})();
